(function (document) {

    var selectors = {
        filterBarBlog: '.template-article .filter-bar-blog',
    
    };
  
    let filterBarBlog = document.querySelector(selectors.filterBarBlog);

    document.addEventListener("scroll", function () {
      positionFromTop = window.pageYOffset;
      if (positionFromTop > 25) {
        filterBarBlog.classList.add("move-top")
      } else {
        filterBarBlog.classList.remove("move-top")
      }
    }, false);
  
    document.addEventListener("load", function () {
      positionFromTop = window.pageYOffset;
      if (positionFromTop > 25) {
        filterBarBlog.classList.add("move-top")
      } else {
        filterBarBlog.classList.remove("move-top")
      }
    });
  
  
  
})(document);